import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { NeuButton } from "../../components/neu/Neu";
import { uploadBackup } from "../../api/backups";

// رفع ملف نسخة احتياطية من ملفات الجهاز واستعادة السجلات المفقودة منه.
export const BackupUpload = ({ onDone }) => {
  const { t } = useTranslation();
  const input = useRef(null);
  const [percent, setPercent] = useState(null);

  const pick = (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    if (!/\.zip$/i.test(file.name)) {
      toast.error(t("backups.err.not_a_helcoo_backup"));
      return;
    }
    send(file);
  };

  const send = async (file) => {
    setPercent(0);
    try {
      const res = await uploadBackup(file, setPercent);
      toast.success(
        res.restored_total
          ? t("backups.uploadRestored", { count: res.restored_total })
          : t("backups.uploadNothing"),
      );
      onDone?.();
    } catch (error) {
      const code = error?.response?.data?.detail?.code;
      toast.error(code ? t(`backups.err.${code}`, t("errors.generic")) : t("errors.generic"));
    } finally {
      setPercent(null);
    }
  };

  return (
    <>
      <input
        ref={input}
        type="file"
        accept="*/*"
        className="hidden"
        data-testid="backup-upload-input"
        onChange={pick}
      />
      <NeuButton
        className="mt-3 flex w-full items-center justify-center gap-2 py-3 sm:w-auto sm:px-6"
        data-testid="backup-upload-btn"
        disabled={percent !== null}
        onClick={() => input.current?.click()}
      >
        <Upload className="h-4 w-4" />
        {percent === null ? t("backups.upload") : t("backups.uploading", { percent })}
      </NeuButton>
    </>
  );
};
